/*
 * Advent Calendar guard
 * The Limited Edition Advent Calendar ships in its own box, so it can't share a cart with anything else.
 *  - Calendar added to a cart that has other items: the other items are removed.
 *  - Anything added to a cart that already has the calendar: the new item is removed.
 * Runs after every cart change (fetch, XHR) and on page load, so it works with any cart drawer.
 */
(function () {
  'use strict';
  if (window.__hhcAdventGuard) return;
  window.__hhcAdventGuard = true;

  var CALENDAR_PRODUCT_ID = 9608008302831;
  var CALENDAR_HANDLE = 'limited-edition-advent-calendar';
  var CART_CHANGE_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?([?#]|$)/;

  var originalFetch = window.fetch;
  var knownKeys = null;
  var queue = Promise.resolve();

  function isCalendar(item) {
    return item.product_id === CALENDAR_PRODUCT_ID ||
      item.handle === CALENDAR_HANDLE ||
      (item.url || '').indexOf('/products/' + CALENDAR_HANDLE) === 0;
  }

  function titles(items) {
    return items.map(function (i) { return i.product_title || i.title; }).join(', ');
  }

  function showMessage(text) {
    function render() {
      var old = document.getElementById('hhc-advent-guard');
      if (old && old.parentNode) old.parentNode.removeChild(old);

      var box = document.createElement('div');
      box.id = 'hhc-advent-guard';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:2147483647;' +
        'width:92%;max-width:520px;box-sizing:border-box;background:#fff;color:#1a1818;' +
        'border:2px solid #9d1c30;border-left-width:8px;box-shadow:0 6px 24px rgba(0,0,0,.3);' +
        'padding:16px 44px 16px 18px;font:15px/1.5 Roboto,Arial,sans-serif;';

      var p = document.createElement('div');
      p.textContent = text;
      box.appendChild(p);

      var close = document.createElement('button');
      close.type = 'button';
      close.setAttribute('aria-label', 'Close message');
      close.textContent = '×';
      close.style.cssText = 'position:absolute;top:6px;right:10px;border:0;background:none;font-size:26px;line-height:1;cursor:pointer;color:#1a1818;';
      close.onclick = function () { if (box.parentNode) box.parentNode.removeChild(box); };
      box.appendChild(close);

      document.body.appendChild(box);
      setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 20000);
    }
    if (document.body) render();
    else document.addEventListener('DOMContentLoaded', render);
  }

  function removeLines(items) {
    var updates = {};
    items.forEach(function (i) { updates[i.key] = 0; });
    // window.fetch (not the saved original) so cart drawer apps see the change and refresh
    return window.fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }

  function refreshUpcart() {
    // UpCart caches its own copy of the cart, so tell it to reload after we change the cart
    try {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
    } catch (e) {}
  }

  function check() {
    return originalFetch.call(window, '/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); }).then(function (cart) {
      var items = cart.items || [];
      var calendar = items.filter(isCalendar);
      var others = items.filter(function (i) { return !isCalendar(i); });
      var prev = knownKeys;
      knownKeys = items.map(function (i) { return i.key; });

      if (!calendar.length || !others.length) return;

      var calendarIsNew = !prev || calendar.some(function (i) { return prev.indexOf(i.key) === -1; });
      var newOthers = prev ? others.filter(function (i) { return prev.indexOf(i.key) === -1; }) : others;
      var toRemove, message;

      if (!calendarIsNew && newOthers.length) {
        toRemove = newOthers;
        message = 'The Limited Edition Advent Calendar ships in its own box and can’t be combined with other items, so we didn’t add: ' +
          titles(newOthers) + '. Please place a separate order for those.';
      } else {
        toRemove = others;
        message = 'The Limited Edition Advent Calendar ships in its own box and can’t be combined with other items, so we removed these from your cart: ' +
          titles(others) + '. You’re welcome to place a separate order for them.';
      }

      return removeLines(toRemove).then(function (newCart) {
        knownKeys = ((newCart && newCart.items) || []).map(function (i) { return i.key; });
        refreshUpcart();
        showMessage(message);
      });
    });
  }

  function enforce() {
    queue = queue.then(check).catch(function () {});
    return queue;
  }

  if (originalFetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var result = originalFetch.apply(this, arguments);
      if (CART_CHANGE_RE.test(url)) {
        result.then(function () { enforce(); }, function () {});
      }
      return result;
    };
  }

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__hhcUrl = String(url || '');
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (CART_CHANGE_RE.test(this.__hhcUrl || '')) {
      this.addEventListener('loadend', function () { enforce(); });
    }
    return xhrSend.apply(this, arguments);
  };

  enforce();
  window.addEventListener('pageshow', function (e) { if (e.persisted) enforce(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') enforce();
  });
})();
